import getWindow from "../utils/window";

export function getAndPersistValue(key) {
  const s = getWindow().s;
  const value = s.getAndPersistValue(null, key);

  return value === "no value" || value === "" ? null : value;
}
